import {
    ADD_MDF_WHITE,
    DELETE_MDF_WHITE,
    GET_MDF_WHITE,

    GET_MDF_COLOR,
    GET_DETAILS_MDF_COLOR,
    GET_LIST_MDF_COLOR,
    SEND_FORM,
    GET_ALL_LIST_MDF,
    SEND_EDIT_FORM,
    SEND_CHAT,
    GET_CHAT,
    GET_IMAGE_MDF,
    GET_FINAL_LIST_MDF,
    SEND_CHAT_TICKET,
    GET_CHAT_TICKET,
    GET_CATEGORY

} from "../action/userProduct";







const initialState = {

    mobile: null,

}




export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_MDF_WHITE:
            return { ...state, data: action.data };
        case DELETE_MDF_WHITE:
            return { ...state, data: action.data };
        case GET_MDF_WHITE:
            return { ...state, data: action.data };
        case GET_MDF_COLOR:
            return { ...state, data: action.data };
        case GET_DETAILS_MDF_COLOR:
            return { ...state, data: action.data };
        case GET_LIST_MDF_COLOR:
            return { ...state, data: action.data };
        case SEND_FORM:
            return { ...state, data: action.data };
        case SEND_EDIT_FORM:
            return { ...state, data: action.data };
        case GET_ALL_LIST_MDF:
            return { ...state, data: action.data };
        case SEND_CHAT:
            return { ...state, data: action.data };
        case SEND_CHAT_TICKET:
            return { ...state, data: action.data };
        case GET_CHAT:
            return { ...state, data: action.data };
        case GET_CHAT_TICKET:
            return { ...state, data: action.data }
        case GET_IMAGE_MDF:
            return { ...state, data: action.data };
        case GET_FINAL_LIST_MDF:
            return { ...state, data: action.data };
        case GET_CATEGORY:
            return { ...state, data: action.data };

        default:
            return state;
    }
}
